import equipmentModule from './modules/equipmentDetails';
import userThermometryModule from './modules/userThermometry';
import equipmentsListModule from './modules/equipmentsListDisplay';

export default {
    equipmentDetails: equipmentModule,
    userThermometry: userThermometryModule,
    equipmentsListDisplay: equipmentsListModule
}